import each from "lodash/each";
import find from "lodash/find";
import findIndex from "lodash/findIndex";
import range from "lodash/range";
import uniq from "lodash/uniq";
import without from "lodash/without";

export const MixinOverlays = {
  methods: {
    onOverlayDragged(obj, overlay) {
      if (obj.first) {
        this.dragStartX = obj.clientX - obj.el.getBoundingClientRect().left;
        this.dragStartBox = obj.el.getBoundingClientRect();
        this.lastOverlayEventType = "click";
        this.setClickedTimelineItem({ type: "overlay", id: overlay.id });
      }
      if ("offsetX" in obj) {
        // Check the Y movement for layer adjustments.
        var drag_layer = -(
          Math.ceil(
            (obj.clientY - this.dragStartBox.bottom) / this.overlaysRowHeight
          ) - overlay.layer
        );
        var overlay_layer = find(this.show.data.overlayArray, {
          id: overlay.id
        }).layer;
        if (drag_layer != overlay_layer) {
          // drag layer is different than the overlay layer.
          // trigger a swap to the new layer.
          var newLayerObject = {
            overlay_id: overlay.id,
            new_layer: drag_layer
          };
          this.$store.dispatch(
            "overlays/updateOverlayByIdToLayer",
            newLayerObject
          );
        }

        // Check with X movement for time adjustment.
        // Deal with drags left and right on timeline.
        var secPerPixel = this.show.data.audio.duration / this.timelineWidth;
        var parentX = this.$refs.timeline.getBoundingClientRect().left;
        var newTime =
          (obj.clientX - parentX - this.dragStartX - this.overlayHandleWidth) *
          secPerPixel;
        if (newTime < 0) {
          newTime = 0;
        }
        var updateObj = {
          overlay_id: overlay.id,
          inpoint: newTime,
          sortAtEnd: false
        };
        this.$store.dispatch("show/updateOverlayByIdToSeconds", updateObj);

        if (!this.groupedOverlayIds.includes(overlay.id)) {
          // When dragging, the id always has to be in the group.
          this.setOverlayGroup(overlay.id, obj.evt);
          //this.groupedSlideIds.push(slide.id);
          //this.$store.commit("show/setGroupedSlideIds", this.groupedSlideIds);
        }

        this.lastOverlayEventType = "drag";
      }
      if (obj.last) {
        console.log(this.lastOverlayEventType);
        if (this.lastOverlayEventType != "drag") {
          this.setOverlayGroup(overlay.id, obj.evt);
        }
        this.$emit("refreshPlayer");
      }
    },
    onOverlayStartDragged(obj, overlay) {
      //console.log(obj, overlay);
      if (obj.first) {
        this.dragStartX = obj.clientX - obj.el.getBoundingClientRect().left;
      }
      // Find the overlay by id, as this component might not have latest data.
      var _overlay = find(this.show.data.overlayArray, { id: overlay.id });
      if ("offsetX" in obj) {
        var secPerPixel = this.show.data.audio.duration / this.timelineWidth;
        var parentX = this.$refs.timeline.getBoundingClientRect().left;
        var newTime = (obj.clientX - parentX - this.dragStartX) * secPerPixel;
        if (newTime < 0) {
          newTime = 0;
        }
        var previousOutpoint = _overlay.inpoint + _overlay.duration;
        var newDuration = previousOutpoint - newTime;
        var minimumDuration = 1;
        if (newDuration < minimumDuration) {
          return;
        }
        var updateObj = {
          overlay_id: overlay.id,
          inpoint: newTime,
          duration: newDuration,
          sortAtEnd: true
        };
        this.$store.dispatch("show/updateOverlayByIdToSeconds", updateObj);

        if (!this.groupedOverlayIds.includes(overlay.id)) {
          // When dragging, the id always has to be in the group.
          this.setOverlayGroup(overlay.id, obj.evt);
          //this.groupedSlideIds.push(slide.id);
          //this.$store.commit("show/setGroupedSlideIds", this.groupedSlideIds);
        }

        this.lastOverlayEventType = "drag";
      }
      if (obj.last) {
        console.log(this.lastOverlayEventType);
        if (this.lastOverlayEventType != "drag") {
          this.setOverlayGroup(overlay.id, obj.evt);
        }
        this.$emit("refreshPlayer");
      }
    },
    onOverlayEndDragged(obj, overlay) {
      //console.log(obj, overlay);
      if (obj.first) {
        this.dragStartX =
          obj.clientX -
          obj.el.getBoundingClientRect().left -
          this.overlayHandleWidth;
      }
      // Find the overlay by id, as this component might not have latest data.
      var _overlay = find(this.show.data.overlayArray, { id: overlay.id });
      if ("offsetX" in obj) {
        var secPerPixel = this.show.data.audio.duration / this.timelineWidth;
        var parentX = this.$refs.timeline.getBoundingClientRect().left;
        var newTime = (obj.clientX - parentX - this.dragStartX) * secPerPixel;
        if (newTime < 0) {
          newTime = 0;
        }
        var newDuration = newTime - _overlay.inpoint;
        var minimumDuration = 1;
        if (newDuration < minimumDuration) {
          return;
        }
        var updateObj = {
          overlay_id: overlay.id,
          duration: newDuration,
          sortAtEnd: true
        };
        this.$store.dispatch("show/updateOverlayByIdToSeconds", updateObj);

        if (!this.groupedOverlayIds.includes(overlay.id)) {
          // When dragging, the id always has to be in the group.
          this.setOverlayGroup(overlay.id, obj.evt);
          //this.groupedSlideIds.push(slide.id);
          //this.$store.commit("show/setGroupedSlideIds", this.groupedSlideIds);
        }
        this.lastOverlayEventType = "drag";
      }
      if (obj.last) {
        console.log(this.lastOverlayEventType);
        if (this.lastOverlayEventType != "drag") {
          this.setOverlayGroup(overlay.id, obj.evt);
        }
        this.$emit("refreshPlayer");
      }
    },
    overlayStyle(overlay) {
      //console.log(idx);
      var width =
        ((overlay.duration * 1000) / (this.show.data.audio.duration * 1000)) *
        this.timelineWidth;
      width = width - this.overlayHandleWidth * 2;
      return {
        top:
          (this.overlayCount - overlay.layer - 1) * this.overlaysRowHeight +
          "px",
        width: width + "px",
        height: this.overlaysRowHeight + "px",
        "padding-left": this.overlayHandleWidth + 2 + "px",
        left:
          ((overlay.inpoint * 1000) / (this.show.data.audio.duration * 1000)) *
            this.timelineWidth +
          this.overlayHandleWidth +
          "px"
      };
    },
    overlayStartStyle(overlay) {
      //console.log(idx);
      var width = this.overlayHandleWidth;
      return {
        top:
          (this.overlayCount - overlay.layer - 1) * this.overlaysRowHeight +
          "px",
        width: width + "px",
        height: this.overlaysRowHeight + "px",
        left:
          ((overlay.inpoint * 1000) / (this.show.data.audio.duration * 1000)) *
            this.timelineWidth +
          "px"
      };
    },
    overlayEndStyle(overlay) {
      //console.log(idx);
      var width =
        ((overlay.duration * 1000) / (this.show.data.audio.duration * 1000)) *
        this.timelineWidth;
      var endWidth = this.overlayHandleWidth;
      return {
        top:
          (this.overlayCount - overlay.layer - 1) * this.overlaysRowHeight +
          "px",
        width: endWidth + "px",
        height: this.overlaysRowHeight + "px",
        left:
          ((overlay.inpoint * 1000) / (this.show.data.audio.duration * 1000)) *
            this.timelineWidth +
          width -
          endWidth +
          "px"
      };
    },

    overlayRailStyle(overlay, idx) {
      //console.log(idx);
      return {
        top: idx * this.overlaysRowHeight + "px",
        width: this.timelineWidth + "px",
        height: this.overlaysRowHeight + "px"
      };
    },
    setOverlayGroup(overlayId, $event) {
      console.log(
        "setOverlayGroup",
        overlayId,
        $event.shiftKey,
        $event.metaKey,
        $event.ctrlKey
      );
      var overlayArray = this.show.data.overlayArray || [];
      var saveLastSelected = true;

      if (!$event.shiftKey && !$event.metaKey && !$event.ctrlKey) {
        // No modifier keys down, just reset groupedOverlayIds;
        this.groupedOverlayIds = [overlayId];
        this.groupedSlideIds = []; // Clear the slide ids in this case.
      } else {
        // We've got a key modifier, let's see what we can do.
        // Single slide toggle modifier.
        if ($event.metaKey || $event.ctrlKey) {
          // Add to existing groupedSlides.
          if (this.groupedOverlayIds.includes(overlayId)) {
            this.groupedOverlayIds = without(this.groupedOverlayIds, overlayId);
            saveLastSelected = false;
          } else {
            this.groupedOverlayIds.push(overlayId);
          }
        }

        // Group modifier.
        if ($event.shiftKey) {
          // Toggle the slide as normal.
          if (this.groupedOverlayIds.includes(overlayId)) {
            this.groupedOverlayIds = without(this.groupedOverlayIds, overlayId);
            saveLastSelected = false;
          } else {
            this.groupedOverlayIds.push(overlayId);
          }
          // Then select all items from the closest selected to this overlayId.
          if (this.lastOverlayIdSelected) {
            var indexOfLastSelected = findIndex(overlayArray, {
              id: this.lastOverlayIdSelected
            });
            var indexOfSelected = findIndex(overlayArray, {
              id: overlayId
            });
            if (indexOfLastSelected > -1) {
              each(range(indexOfLastSelected, indexOfSelected), n => {
                var _id = overlayArray[n].id;
                this.groupedOverlayIds.push(_id);
              });
              this.groupedOverlayIds = uniq(this.groupedOverlayIds);
            }
          }
        }
      }

      if (saveLastSelected) {
        this.lastOverlayIdSelected = overlayId;
      } else {
        this.lastOverlayIdSelected = null;
      }

      console.log("groupedOverlayIds", this.groupedOverlayIds);
      this.$store.dispatch(
        "show/updateGroupedOverlayIds",
        this.groupedOverlayIds,
        {
          root: true
        }
      );
      this.$store.dispatch("show/updateGroupedSlideIds", this.groupedSlideIds, {
        root: true
      });
    }
  }
};
